// HeaderMenu.tsx
import {
  Form,
  Link,
  useRouteLoaderData,
} from "@remix-run/react";
import clsx from "clsx";
import React from "react";
import type { loader } from "./../../root";
import { m } from "framer-motion";

interface HeaderMenuProps {
  menuRef: React.RefObject<HTMLDivElement>;
}

const listCLass = clsx(
  "py-16",
  "flex",
  "flex-col",
  "gap-12",
  "w-180",
);

const HeaderMenu: React.FC<HeaderMenuProps> = ({
  menuRef,
}) => {
  const root =
    useRouteLoaderData<typeof loader>("root");
  const userData = root?.userData;
  const menu = root?.subscription_active
    ? [
        {
          link: `/user/${userData?.display_id}`,
          label: "マイページ",
        },
        {
          link: `/dashboard`,
          label: "記事を書く",
        },
        {
          link: `/stamp-posts`,
          label: "反応した記事",
        },
        /* {
          link: `/blockform`,
          label: "ブロック",
        }, */
      ]
    : [
        {
          link: `/user/${userData?.display_id}`,
          label: "マイページ",
        },
        {
          link: `/dashboard`,
          label: "記事を書く",
        },
        {
          link: `/stamp-posts`,
          label: "反応した記事",
        },
      ];

  return (
    <m.div
      exit={{ opacity: 0 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      ref={menuRef}
      className={clsx(
        "absolute",
        "right-0",
        "top-0",
        "whitespace-nowrap",
        "z-20",
        "shadow-lg",
        "bg-white",
        "py-10",
        "px-32",
        "border",
        "rounded-[10px]",
      )}
    >
      <div
        className={clsx(
          "divide-y-[1px]",
          "text-left",
        )}
      >
        <ul className={clsx(listCLass)}>
          {menu.map((el, i) => {
            return (
              <li key={i}>
                <Link to={el.link}>
                  {el.label}
                </Link>
              </li>
            );
          })}
        </ul>
        <ul className={clsx(listCLass)}>
          <li>
            <Form
              action="/stripe-portal"
              method="post"
            >
              <button>支払い情報</button>
            </Form>
          </li>
          {[
            userData
              ? {
                  link: `/settings`,
                  label: "設定",
                }
              : null,
            {
              link: "",
              label: "ヘルプ",
            },
          ]
            .filter((el) => el !== null)
            .map((el, i) => {
              return (
                <li key={i}>
                  <Link to={el.link}>
                    {el.label}
                  </Link>
                </li>
              );
            })}
        </ul>
        <ul className={clsx(listCLass)}>
          <li>
            <Form
              method={"post"}
              action="/signout"
            >
              <button className={clsx("")}>
                ログアウト
              </button>
            </Form>
          </li>
        </ul>
      </div>
    </m.div>
  );
};

export default HeaderMenu;
